@if (photos().length) {
  <div class="visit-photo ai-derm" layout="row" layout-align="space-around none" layout-wrap>
    @for(photo of photos(); track photo.id; let i = $index) {
      <div class="visit-photos-container outer-container">
        <div class="photo-image-wrapper">
          <img
            class="photo-responsive"
            [file]="photo"
            (base64Ready)="onBase64ImageRerender(photo, $event)"
            [class.photo-rejected]="photo.rejected"
            [alt]="'Photo ' + i"
            [id]="'photo-responsive-' + photo.id"
            [style.transform]="getRotation(photo.id)"
            />
            @if (!isUserDeleted()) {
              <div class="photo-overlay">
                <button (click)="openPhoto(i)">
                  <i class="icon ion-search"></i>
                </button>
                <button (click)="rotate(photo.id)">
                  <i class="icon ion-android-refresh"></i>
                </button>
              </div>
            }
          </div>
          <div class="ai-derm-text">
            @if (photo.file.status === STATUS_REJECTED || photo.rejected || photo.aiDermInfo?.error) {
              <div class="ai-unavailable">
                @if (photo.file.status === STATUS_REJECTED || photo.rejected) {
                  AI prediction unavailable due to rejected image.
                } @else {
                  {{ photo.aiDermInfo?.error }}
                }
              </div>
            } @else {
              @if (isPhotoAiDermLoading(photo.file.id)) {
                <app-loader-spinner
                  [message]="'Generating AI Predictions...'"
                ></app-loader-spinner>
              }
              @if (photo.aiDermInfo?.predictions?.length) {
                <div class="ai-derm-results">
                  <h4>AI Generated</h4>
                  <ul>
                    @for (result of photo.aiDermInfo?.predictions; track result) {
                      <li>
                        <span>
                          <a [href]="result.read_more_url" target="_blank" rel="noopener noreferrer">
                            <strong>{{ result.name }}</strong>
                          </a>
                          <span class="info-wrapper">
                            <i class="icon ion-information-circled"></i>
                            <span class="icd-code">{{result.icd_10}}</span>
                          </span>
                          &nbsp; {{ result.confidence * 100 | number : '1.0-1' }}%
                        </span>
                      </li>
                    }
                  </ul>
                  @if (photo.aiDermInfo?.created) {
                    <p class="times-stamp">
                      Created: {{ formatTime(photo.aiDermInfo?.created) }}
                    </p>
                  }
                </div>
              }
            }
            @if (requiresAction() && !isUserDeleted()) {
              <div class="btns-row">
                @if (!photo.rejected) {
                  <div>
                    <button class="btn btn-danger btn-sm" (click)="setRejectStatus(photo.id, true)">Reject</button>
                  </div>
                }
                @if (photo.rejected && !photo.deleted) {
                  <div>
                    <button class="btn btn-success btn-sm" (click)="setRejectStatus(photo.id, false)">Approve</button>
                  </div>
                }
              </div>
            }
          </div>
          @if (photo.rejected) {
            <div class="form-group">
              @if (this.photoFormGroups().get(photo.id); as photoFormGroup) {
                <form [formGroup]="photoFormGroup">
                  <label for="rejection-note-{{ i }}">Rejection Note:</label>
                  <textarea
                    id="rejection-note-{{ i }}"
                    (input)="onFormControlChange(photoFormGroup)"
                    formControlName="rejectionNote"
                    class="form-control"
                    name="rejection-note-{{ i }}"
                    placeholder="Type your rejection message here"
                  ></textarea>
                </form>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (!photos().length) {
    <div>
      <p>No photos available.</p>
    </div>
  }

  <!-- Alerts -->
  @if (isApproved() && photos().length) {
    <div class="alert alert-success">Exam photos approved.</div>
  }

  @if (waitingForUpload()) {
    <div class="alert alert-danger">Waiting for patient to reupload one or more photos...</div>
  }

  @if (requiresAction() && photos().length) {
    <div class="text-center m-t-md">
      <button class="btn btn-danger" (click)="onReject()" [disabled]="rejectCTADisabled()">Reject</button>
      <button class="btn btn-default" (click)="onApprove()" [disabled]="approveCTADisabled()">Approve</button>
    </div>
  }
